import { INVALID_PASSWORD_CONFIRM } from "@/constants/invalids";
import { validator } from "@/utils/validator";

export const registerSchema = validator.object().shape({
  email: validator.string().emptyToNull().email().max(60).autoTransformToHalfWidth().label("メールアドレス").required(),
  password: validator.string().emptyToNull().strongPassword(undefined, 12).label("パスワード").required(),
  confirmPassword: validator
    .string()
    .emptyToNull()
    .trim()
    .label("パスワード（確認用）")
    .oneOf([validator.ref("password")], INVALID_PASSWORD_CONFIRM)
    .required(),
});
